import ContentLoader from 'stimulus-content-loader'

export default class extends ContentLoader {
  static values = {
    ...super.values,
    replaceStrategy: { type: String, default: "inner" }
  }

  // Override method to add the capability to replace either the inner or the outer html of the element
  fetch () {
    fetch(this.urlValue)
      .then((response) => response.text())
      .then((html) => {
        if (this.replaceStrategyValue === "outer") {
          this.element.outerHTML = html
        } else {
          this.element.innerHTML = html
        }

        if (this.loadScriptsValue) {
          this.loadScripts()
        }
      })
  }
}
